<div [class]="narrow | widthClass">
  <div [class]="columns | columnsClass">
    <app-card *ngFor="let card of cards" [headline]="card.title" [subHeadline]="card.subtitle" [body]="card.text" [image]="card.image" [link]="card.link" [variant]="version"></app-card>
  </div>
</div>
